<template>
  <div :class="classes">
    <div v-if="showHead" :class="`${prefixCardClass}-header`" :style="headerStyle">
      <slot name="head"></slot>
    </div>
    <div :class="`${prefixCardClass}-block`" :style="contentStyle">
      <slot></slot>
    </div>
    <div v-if="showFooter" :class="`${prefixCardClass}-footer`" :style="footerStyle">
      <slot name="foot"></slot>
    </div>
  </div>
</template>
<script>
import { PREFIX_CLASS } from '../../utils/constants'

const PREFIX_CARD_CLASS = `${PREFIX_CLASS}card`
const DEFAULT_PADDING = 20

export default {
  name: 'TCard',
  props: {
    shadowed: {
      type: Boolean,
      default: false
    },
    shadowedHover: {
      type: Boolean,
      default: false
    },
    bordered: {
      type: Boolean,
      default: false
    },
    headerPadding: {
      type: [Number, String],
      default: DEFAULT_PADDING
    },
    bodyPadding: {
      type: [Number, String],
      default: DEFAULT_PADDING
    },
    footerPadding: {
      type: [Number, String],
      default: 10
    }
  },
  data() {
    return {
      showHead: true,
      showFooter: true
    }
  },
  computed: {
    prefixCardClass() {
      return PREFIX_CARD_CLASS
    },
    classes() {
      return [
        PREFIX_CARD_CLASS,
        {
          [`${PREFIX_CARD_CLASS}-has-shadowed`]: this.shadowed,
          [`${PREFIX_CARD_CLASS}-shadowed-hover`]: this.shadowedHover,
          [`${PREFIX_CARD_CLASS}-has-border`]: this.bordered
        }
      ]
    },
    headerStyle() {
      return {
        padding: this.headerPadding + 'px'
      }
    },
    contentStyle() {
      return {
        padding: this.bodyPadding + 'px'
      }
    },
    footerStyle() {
      return {
        padding: this.footerPadding + 'px'
      }
    }
  },
  mounted() {
    this.showHead = this.$slots.head !== undefined
    this.showFooter = this.$slots.foot !== undefined
  }
}
</script>



// WEBPACK FOOTER //
// src/module/card/card.vue